import React from 'react';
import styles from './KPICard.module.css';
import { ArrowUpIcon, ArrowDownIcon, MinusIcon } from '@heroicons/react/24/solid';

export default function KPICard({ label, value, icon: Icon, badge, color = '#2B9DD4', trend, sub }) {
  const TrendIcon = trend?.direction === 'up' ? ArrowUpIcon
    : trend?.direction === 'down' ? ArrowDownIcon : MinusIcon;
  const trendColor = trend?.direction === 'up' ? 'var(--trend-up)'
    : trend?.direction === 'down' ? 'var(--trend-down)' : 'var(--trend-flat)';

  return (
    <div className={styles.card} style={{ '--accent': color }}>
      <span className={styles.accentEdge} />
      <div className={styles.top}>
        {badge ? (
          <div className={styles.badgeBox}>
            <img src={badge} alt="" className={styles.badgeImg} />
          </div>
        ) : (
          <div className={styles.iconBox} style={{ background: `${color}18`, border: `1px solid ${color}30` }}>
            {Icon && <Icon style={{ width: 20, height: 20, color }} />}
          </div>
        )}
        {trend && (
          <div className={styles.trendBadge} style={{ color: trendColor, background: `${trendColor}15` }}>
            <TrendIcon style={{ width: 10, height: 10 }} />
            <span>{trend.value}</span>
          </div>
        )}
      </div>
      <div className={styles.value}>{value ?? '—'}</div>
      <div className={styles.label}>{label}</div>
      {sub && <div className={styles.sub}>{sub}</div>}
    </div>
  );
}
